<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.users.dialog.duplicate-error' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ (isEdit ? 'mes.administration.users.dialog.edit-employee' : 'mes.administration.users.dialog.create-employee') | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['alias'].invalid && controls['alias'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.alias.error.' + getFirstValidationErrorName('alias') | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.alias.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="alias" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['firstName'].invalid && controls['firstName'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.firstname.error.' + getFirstValidationErrorName('firstName') | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.firstname.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="firstName" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['lastName'].invalid && controls['lastName'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.lastname.error.' + getFirstValidationErrorName('lastName') | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.lastname.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="lastName" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['departmentId'].invalid && controls['departmentId'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.department.error' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.department.label' | translate }}</mat-label>
			<mat-select formControlName="departmentId">
				@for (department of activeDepartments; track department) {
				<mat-option [value]="department.id">{{ department.alias }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['teamProfileId'].invalid && controls['teamProfileId'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.teamprofile.error' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.teamprofile.label' | translate }}</mat-label>
			<mat-select formControlName="teamProfileId">
				@for (teamProfile of teamProfiles; track teamProfile) {
				<mat-option [value]="teamProfile.id">({{teamProfile.alias}}) {{teamProfile.description}}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['firstWorkDate'].hasError('matDatepickerParse') && controls['firstWorkDate'].touched) {
			<mat-error>{{ 'mes.administration.users.dialog.firstWorkDate.error.pattern' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.users.dialog.firstWorkDate.label' | translate }}</mat-label>
			<input matInput [matDatepicker]="firstWorkDatePicker" formControlName="firstWorkDate" />
			<mat-datepicker-toggle matIconSuffix [for]="firstWorkDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #firstWorkDatePicker></mat-datepicker>
			@if (form.get('firstWorkDate').value) {
			<button mat-icon-button matSuffix type="button" (click)="form.get('firstWorkDate').setValue(null)">
				<mat-icon>close</mat-icon>
			</button>
			}
		</mat-form-field>

		<mat-label class="mat-body-1">{{'mes.administration.users.dialog.active.label' | translate}}</mat-label>
		<mat-checkbox formControlName="isActive" />
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'general.ok' | translate }}</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'general.cancel' | translate }}</button>
	</mat-dialog-actions>
</form>
